import Phaser from 'phaser';
import { Colors } from '../consts/Colors';
import { Fonts } from '../consts/Fonts';
import ScoreContainer from './ScoreContainer.js';
import RoundedButton from './buttons/RoundedButton.js';

export default class EndBoard extends Phaser.GameObjects.Container {
    constructor(scene, x, y, {scoreBravo, scoreMauvais}) {
        super(scene, x, y, []);
        scene.add.existing(this);

        this.scene = scene;
        this.depth = 1;

        this.score = {
            bravo: scoreBravo,
            mauvais: scoreMauvais
        };

        const scoreContainer = new ScoreContainer(this.scene, 360, 63, {scoreBravo: this.score.bravo, scoreMauvais: this.score.mauvais})
        this.add(scoreContainer)

        this.addTexteFin()
    }

    addTexteFin(){
        // Choix du texte à afficher en fonction du score
        var isTrue = false
        var txtTitre = "Félicitations !"
        var txt = "Les ratios financiers n'ont plus de secret pour vous ! Il est temps de découvrir d'autres quiz."
        if ((this.score.bravo) <= 6 && (this.score.bravo) >= 4) {
            txtTitre = "C'est un bon début !"
            txt = "Rejouez avant de découvrir d’autres quiz !"
            // txt = "Rejouez avant de regarder la vidéo suivante sur ******** !"
        } else if ((this.score.bravo) <= 3) {
            txtTitre = "Vous pouvez faire mieux !"
            txt = "Regardez de nouveau la vidéo et rejouez !"
        } else {
            isTrue = true
        }

        const title = this.scene.add.text(625, 125, txtTitre, {
            fontSize: "40px",
            fontFamily: Fonts.MassiliaExtraBold,
            color: Colors.Text.White,
            align: "left",
            wordWrap: {width: 420}
        }).setOrigin(0, 1)
        this.add(title)

        const content = this.scene.add.text(title.x, title.y + 23, txt, {
            fontSize: "30px",
            fontFamily: Fonts.MassiliaRegular,
            color: Colors.Text.White,
            align: "left",
            wordWrap: {width: 420}
        }).setOrigin(0)
        this.add(content)

        const line = this.scene.add.rexRoundRectangle(1093, 33.5, 2, 250, 1, Colors.Elmt.White).setOrigin(0.5, 0)
        this.add(line)

        if(!isTrue) {
            this.addButtonsRejouer()
        }else{
            this.addButtonsPartager()
        }
    }

    addButtonsPartager(){
        const deltaY = 70
        let Y = 34 + 52/2
        const X = 1490

        const boutonPartager = new RoundedButton(this.scene, X, Y, {
            width: 205,
            height: 52,
            text: "   Partager",
            textColor: Colors.Text.White,
            backgroundColor: Colors.Elmt.DarkBlue,
            strokeColor: Colors.Elmt.White,
            hoverTextColor: Colors.Text.DarkBlue,
            hoverBackgroundColor: Colors.Elmt.White,
            fontSize: 24,
        })
        let icon = this.scene.add.image(-boutonPartager.textButton.width/2, 0, 'logoLinkedin').setOrigin(1, 0.5)
        boutonPartager.add(icon);
        this.add(boutonPartager);
        boutonPartager.on('pointerover', () => {icon.setTint(Colors.Elmt.DarkBlue)})
        boutonPartager.on('pointerout', () => {icon.setTint(Colors.Elmt.White)})
        boutonPartager.setClickFunction(() => {
            window.open("https://www.linkedin.com/shareArticle/?url=https%3A%2F%2Fwww.mesquestionsdentrepreneur.fr%2Fsites%2Fbdf_mqde%2Fuploads%2Fratios-financiers-simple-comme-compta%2F&text=%E2%9C%85+D%C3%A9fi+ratios+financiers+%3A+r%C3%A9ussi+%21%0D%0AJe+viens+de+tester+mes+connaissances+avec+un+quiz+propos%C3%A9+par+la+Banque+de+France+%E2%80%93+EDUCFI.%0D%0A%F0%9F%8E%AF+Verdict+%3A+mission+accomplie%E2%80%A6+et%2C+surtout%2C+quelques+bons+r%C3%A9flexes+bien+ancr%C3%A9s+pour+mieux+comprendre+et+analyser+les+ratios+financiers.%0D%0AParce+que+ma%C3%AEtriser+ses+indicateurs+financiers+est+essentiel+pour+piloter+son+activit%C3%A9%2C+ces+formats+ludiques+sont+une+excellente+mani%C3%A8re+de+se+former+autrement.%0D%0A%F0%9F%91%89+Et+vous%2C+pr%C3%AAt%28e%29s+%C3%A0+relever+le+d%C3%A9fi%EF%BC%9F#overlay_share-modal", '_blank');
            // window.open("https://www.linkedin.com/feed/?shareActive=true&text=%E2%9C%85%20D%C3%A9fi%20tr%C3%A9sorerie%20%3A%20r%C3%A9ussi%20%21%0A%0AJe+viens+de+tester+mes+connaissances+gr%C3%A2ce+%C3%A0+un+quiz+propos%C3%A9+par+Banque+de+France+%E2%80%93+EDUCFI.+https://www.mesquestionsdentrepreneur.fr/espace-enseignants-accompagnateurs/quiz-interactifs", '_blank');
            // window.open("https://youtu.be/l1nTs54zj7Q?si=a2zWX810A7j4whtg", '_blank');
        })

        Y += deltaY

        const boutonVideo = new RoundedButton(this.scene, X, Y, {
            width: 326,
            height: 52,
            text: "Découvrir d’autres quiz",
            textColor: Colors.Text.DarkBlue,
            backgroundColor: Colors.Elmt.White,
            strokeColor: Colors.Elmt.White,
            hoverTextColor: Colors.Text.White,
            hoverBackgroundColor: Colors.Elmt.DarkBlue,
            fontSize: 24,
        })
        // const boutonVideo = new RoundedButtonReverted(this.scene, 1035 + 382 / 2, 116 + 52 / 2, 382, 52, "Découvrir la vidéo suivante", Colors.Text.DarkBlue, Colors.Elmt.DarkBlue, 26)
        this.add(boutonVideo);
        boutonVideo.setClickFunction(() => {
            window.open("https://www.mesquestionsdentrepreneur.fr/espace-enseignants-accompagnateurs/quiz-interactifs", '_blank');
        })

        Y += deltaY

        const boutonRejouer = new RoundedButton(this.scene, X, Y, {
            width: 162,
            height: 52,
            text: "Rejouer",
            textColor: Colors.Text.White,
            backgroundColor: Colors.Elmt.DarkBlue,
            strokeColor: Colors.Elmt.White,
            hoverTextColor: Colors.Text.DarkBlue,
            hoverBackgroundColor: Colors.Elmt.White,
            fontSize: 24,
        })
        this.add(boutonRejouer);
        boutonRejouer.setClickFunction(() => {
            this.scene.game.data.score = {
                bravo: 0,
                presque: 0,
                mauvais: 0
            }
            this.scene.scene.start("Menu")
        })

        Y += deltaY

        const boutonTerminer = new RoundedButton(this.scene, X, Y, {
            width: 170,
            height: 52,
            text: "Terminer",
            textColor: Colors.Text.White,
            backgroundColor: Colors.Elmt.DarkBlue,
            strokeColor: Colors.Elmt.White,
            hoverTextColor: Colors.Text.DarkBlue,
            hoverBackgroundColor: Colors.Elmt.White,
            fontSize: 24,
        })
        this.add(boutonTerminer);
        boutonTerminer.rectButton.setStrokeStyle(2, Colors.Elmt.White, 1);
        boutonTerminer.setTextSize("28px")
        boutonTerminer.setClickFunction(() => {
            // this.nextScene()
            this.scene.scene.start('Fin')
        })
    }

    addButtonsRejouer(){
        const deltaY = 70
        const X = 1490
        let Y = 34 + 52/2

        const boutonPartager = new RoundedButton(this.scene, X, Y, {
            width: 205,
            height: 52,
            text: "   Partager",
            textColor: Colors.Text.White,
            backgroundColor: Colors.Elmt.DarkBlue,
            strokeColor: Colors.Elmt.White,
            hoverTextColor: Colors.Text.DarkBlue,
            hoverBackgroundColor: Colors.Elmt.White,
            fontSize: 24,
        })
        let icon = this.scene.add.image(-boutonPartager.textButton.width/2, 0, 'logoLinkedin').setOrigin(1, 0.5)
        boutonPartager.add(icon);
        this.add(boutonPartager);
        boutonPartager.on('pointerover', () => {icon.setTint(Colors.Elmt.DarkBlue)})
        boutonPartager.on('pointerout', () => {icon.setTint(Colors.Elmt.White)})
        boutonPartager.setClickFunction(() => {
            window.open("https://www.linkedin.com/shareArticle/?url=https%3A%2F%2Fwww.mesquestionsdentrepreneur.fr%2Fsites%2Fbdf_mqde%2Fuploads%2Fratios-financiers-simple-comme-compta%2F&text=%E2%9C%85+D%C3%A9fi+ratios+financiers+%3A+r%C3%A9ussi+%21%0D%0AJe+viens+de+tester+mes+connaissances+avec+un+quiz+propos%C3%A9+par+la+Banque+de+France+%E2%80%93+EDUCFI.%0D%0A%F0%9F%8E%AF+Verdict+%3A+mission+accomplie%E2%80%A6+et%2C+surtout%2C+quelques+bons+r%C3%A9flexes+bien+ancr%C3%A9s+pour+mieux+comprendre+et+analyser+les+ratios+financiers.%0D%0AParce+que+ma%C3%AEtriser+ses+indicateurs+financiers+est+essentiel+pour+piloter+son+activit%C3%A9%2C+ces+formats+ludiques+sont+une+excellente+mani%C3%A8re+de+se+former+autrement.%0D%0A%F0%9F%91%89+Et+vous%2C+pr%C3%AAt%28e%29s+%C3%A0+relever+le+d%C3%A9fi%EF%BC%9F#overlay_share-modal", '_blank');
            // window.open("https://www.linkedin.com/feed/?shareActive=true&text=%E2%9C%85%20D%C3%A9fi%20tr%C3%A9sorerie%20%3A%20r%C3%A9ussi%20%21%0A%0AJe+viens+de+tester+mes+connaissances+gr%C3%A2ce+%C3%A0+un+quiz+propos%C3%A9+par+Banque+de+France+%E2%80%93+EDUCFI.+https://www.mesquestionsdentrepreneur.fr/espace-enseignants-accompagnateurs/quiz-interactifs", '_blank');
            // window.open("https://youtu.be/l1nTs54zj7Q?si=a2zWX810A7j4whtg", '_blank');
        })

        Y += deltaY

        const boutonRejouer = new RoundedButton(this.scene, X, Y, {
            width: 162,
            height: 52,
            text: "Rejouer",
            textColor: Colors.Text.DarkBlue,
            backgroundColor: Colors.Elmt.White,
            strokeColor: Colors.Elmt.White,
            hoverTextColor: Colors.Text.White,
            hoverBackgroundColor: Colors.Elmt.DarkBlue,
            fontSize: 24,
        })
        this.add(boutonRejouer);
        boutonRejouer.setClickFunction(() => {
            this.scene.game.data.score = {
                bravo: 0,
                presque: 0,
                mauvais: 0
            }
            this.scene.scene.start("Menu")
        })

        Y += deltaY

        const boutonVideo = new RoundedButton(this.scene, X, Y, {
            width: 326,
            height: 52,
            text: "Découvrir d’autres quiz",
            textColor: Colors.Text.White,
            backgroundColor: Colors.Elmt.DarkBlue,
            strokeColor: Colors.Elmt.White,
            hoverTextColor: Colors.Text.DarkBlue,
            hoverBackgroundColor: Colors.Elmt.White,
            fontSize: 24,
        })
        // const boutonVideo = new RoundedButtonReverted(this.scene, 1035 + 382 / 2, 116 + 52 / 2, 382, 52, "Découvrir la vidéo suivante", Colors.Text.DarkBlue, Colors.Elmt.DarkBlue, 26)
        this.add(boutonVideo);
        boutonVideo.setClickFunction(() => {
            window.open("https://www.mesquestionsdentrepreneur.fr/espace-enseignants-accompagnateurs/quiz-interactifs", '_blank');
        })

        Y += deltaY

        const boutonTerminer = new RoundedButton(this.scene, X, Y, {
            width: 170,
            height: 52,
            text: "Terminer",
            textColor: Colors.Text.White,
            backgroundColor: Colors.Elmt.DarkBlue,
            strokeColor: Colors.Elmt.White,
            hoverTextColor: Colors.Text.DarkBlue,
            hoverBackgroundColor: Colors.Elmt.White,
            fontSize: 24,
        })
        this.add(boutonTerminer);
        boutonTerminer.rectButton.setStrokeStyle(2, Colors.Elmt.White, 1);
        boutonTerminer.setTextSize("28px")
        boutonTerminer.setClickFunction(() => {
            // this.nextScene()
            this.scene.scene.start('Fin')
        })
    }
}